module.exports = __webpack_public_path__ + "media/images/topics/topics-heading-bg-pov-644ddeceeb35153ff7c34c95f28da064.png";